require('jquery-mask-plugin');

$(document).ready(function(){
    $('.date').mask('00/00/0000');
    $('.time').mask('00:00:00');
    $('.date_time').mask('00/00/0000 00:00:00');
    $('.phone').mask('(00) 0000-0000', {
      reverse: false,
      placeholder: 'Ex.: (00) 1234-5678 '
    });
    $('.cellphone').mask('(00) 00000-0000', {
      reverse: false,
      placeholder: 'Ex.: (00) 91234-5678'
    });
    $('.phone_with_ddd').mask('(00) 0000-0000');
    $('.phone_us').mask('(000) 000-0000');
    $('.mixed').mask('AAA 000-S0S');
    $('.cnpj').mask('00.000.000/0000-00', {
      reverse: false,
      placeholder: 'Ex.: 12.345.678/0001-90'
    });
    $('.cpf').mask('000.000.000-00', {
      reverse: true,
      placeholder: 'Ex.: 123.456.789-00'
    });
    $('.rg').mask('ZZ.ZZZ.Z00-00', {
        reverse: true,
        placeholder: 'Ex.: 12.345.678-90',
        translation: {
            'Z': {
                pattern: /[0-9]/,
                optional: true
            }
        }
    });
    $('.money').mask('000.000.000.000.000,00', {reverse: true});
    $('.money2').mask("#.##0,00", {reverse: true});
    $('.ip_address').mask('0ZZ.0ZZ.0ZZ.0ZZ', {
      translation: {
        'Z': {
          pattern: /[0-9]/, optional: true
        }
      }
    });
    $('.ip_address').mask('099.099.099.099');
    $('.percent').mask('##0,00%', {reverse: true});
    $('.clear-if-not-match').mask("00/00/0000", {clearIfNotMatch: true});
    $('.placeholder').mask("00/00/0000", {placeholder: "__/__/____"});
    $('.fallback').mask("00r00r0000", {
        translation: {
          'r': {
            pattern: /[\/]/,
            fallback: '/'
          },
          placeholder: "__/__/____"
        }
      });
    $('.selectonfocus').mask("00/00/0000", {selectOnFocus: true});

    $('.plate').mask('AAA0Z00', {
      placeholder: "Ex: ABC1D23 ou ABC1234",
      translation: {
          'Z': {
              pattern: /[0-9]|[A-Za-z]/, 
              optional: false
          },
          'A': {
              pattern: /[A-Za-z]/, 
              optional: false
          }
      },
      onComplete: function(plate, event, currentField, options){
          const checkPlate = (plate) => {
              const regex = /^[a-zA-Z]{3}([0-9]{4}|[0-9]{1}[a-zA-Z]{1}[0-9]{2})$/;
              return regex.test(plate);
          }

          if(!checkPlate(plate)){
              event.currentTarget.value = null;

              Swal.fire(
                  'Oops...',
                  'Por favor, insira uma placa válida!',
                  'error'
              );
          }


      },
      onKeyPress: function (value, event) {
       event.currentTarget.value = value.toUpperCase();
      }
  });

  $('.renavam').mask('ZZZZZZZZZZZ', {
    placeholder: "Informe os 11 digitos",
    translation: {
        'Z': {
            pattern: /[0-9]/, 
            optional: false
        }
    }
  });
  $('.cep').mask('00000-000', {
    placeholder: 'Ex.: 00000-000',
    onComplete: function (cep) {
        async function getCep(cep) {
            const {
                data: {
                    erro,
                    ...info
                },
                ...response
            } = await axios.get(`https://viacep.com.br/ws/${cep}/json`);

            const street = document.querySelector('input[name="street"]');
            const complement = document.querySelector('input[name="complement"]');
            const district = document.querySelector('input[name="district"]');
            const state = document.querySelector('input[name="state"]');
            const city = document.querySelector('input[name="city"]');

            if (erro) {
              street.value = '';
              complement.value = '';
              district.value = '';
              state.value = '';
              city.value = '';
              return Swal.fire('Oops...', 'Cep Não Encontrado', 'error');
            }

            street.value = `${info.logradouro}`;
            district.value = info.bairro;
            state.value = info.uf;
            city.value = info.localidade;


        }
        getCep(cep);
    },
    onKeyPress: function (cep, event, currentField, options) {
        console.log('A key was pressed!:', cep, ' event: ', event, 'currentField: ', currentField, ' options: ', options);
    },
    onChange: function (cep) {
        console.log('cep changed! ', cep);
    },
    onInvalid: function (val, e, f, invalid, options) {
        let error = invalid[0];
        console.log("Digit: ", error.v, " is invalid for the position: ", error.p, ". We expect something like: ", error.e);
    }
});

});